import { t as textSeparator, o as opportunity, g as clock, h as calendar, s as search, i as ellipsisV, j as amznAdsStormLogo, k as infoCircle, l as angleDown, m as angleUp, d as angleInlineEnd, c as angleInlineStart, n as spinner, p as check, q as exclamationTriangle, r as exclamation, u as externalLink, v as close } from '../localIcons-t7qtQAY6.js';
import { a as angleDoubleRight, b as angleDoubleLeft } from '../classicIcons-BuhvPs5r.js';

const commonIconManifest = {
  close: close.icon,
  'external-link': externalLink.icon,
  exclamation: exclamation.icon,
  'exclamation-triangle': exclamationTriangle.icon,
  check: check.icon,
  spinner: spinner.icon,
  'angle-inline-start': angleInlineStart.icon,
  'angle-inline-end': angleInlineEnd.icon,
  'angle-up': angleUp.icon,
  'angle-down': angleDown.icon,
  'info-circle': infoCircle.icon,
  'amzn-ads-storm-logo': amznAdsStormLogo.icon,
  'ellipsis-v': ellipsisV.icon,
  search: search.icon,
  'angle-double-left': angleDoubleLeft.icon,
  'angle-double-right': angleDoubleRight.icon,
  calendar: calendar.icon,
  clock: clock.icon,
  opportunity: opportunity.icon,
  'text-separator': textSeparator.icon
};

export { commonIconManifest as c };
//# sourceMappingURL=commonIconManifest-DvSs92jo.js.map
